import axios from "axios";

const chave = "befa00b738db4f5d115d61ce533fc463";
const url =
  "https://www.cursoslefisc.com.br/api/certificado/buscarCertificado/";
export default {
  getCertificado(hash) {
    return (
      axios
        .get(`${url}${hash}/${chave}`)
        //   .get(`${url}${hash}`, {
        //     headers: {
        //       Authorization: `Bearer ${chave}`,
        //     },
        //   })
        .then((res) => {
          return res.data; // Use 'return' para enviar os dados para o componente
        })
        .catch((err) => {
          return err.response;
        })
    );
  },
};
